import React from "react";

export default function Logo({ size = 32, withText = true, textClassName = "", className = "" }) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/propera-logo.png"
        alt="Propera"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="select-none"
        draggable={false}
      />
      {withText && (
        <span className={`text-[1.25rem] font-bold tracking-tight text-propera ${textClassName}`}>
          Propera
        </span>
      )}
    </div>
  );
}
